/**
 * The app icon and web-app manifest (apps/web/public). index.html is the
 * proper home for these <link> tags; until it has them, this adds any that are
 * missing at startup, so the tab icon and "Add to Home Screen" work either way.
 * Idempotent: links already in the page are left alone.
 */

interface HeadLink {
  rel: string;
  href: string;
  type?: string;
}

/** Public files, relative to the app's base URL (Vite's `base`, "/" by default). */
const APP_LINKS: readonly HeadLink[] = [
  { rel: 'icon', href: 'favicon.svg', type: 'image/svg+xml' },
  { rel: 'apple-touch-icon', href: 'favicon.svg' },
  { rel: 'manifest', href: 'manifest.webmanifest' },
];

export function ensureAppLinks(doc: Document = document, base: string = import.meta.env.BASE_URL): void {
  for (const link of APP_LINKS) {
    if (doc.head.querySelector(`link[rel="${link.rel}"]`)) continue;
    const el = doc.createElement('link');
    el.rel = link.rel;
    el.href = base + link.href;
    if (link.type) el.type = link.type;
    doc.head.append(el);
  }
}
